import { isNil } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import HelpIcon from "../interface/HelpIcon";

const ModalField = props => (
  <div className="modalField" style={{ flexGrow: isNil(props.flex) ? 1 : props.flex }}>
    <div className="modalFieldLabelRow">
      {props.label ? (
        <label className="modalFieldLabel">
          {props.label}
          {props.helpTooltip ? <HelpIcon tooltip={props.helpTooltip} /> : null}
        </label>
      ) : props.showBlankLabel ? (
        <label className="modalFieldLabel blank">&nbsp;</label>
      ) : null}
      {props.labelContent}
    </div>
    {props.children}
  </div>
);

ModalField.propTypes = {
  label: PropTypes.string,
  labelContent: PropTypeShapes.elementOrArrayOrString,
  showBlankLabel: PropTypes.bool,
  children: PropTypeShapes.elementOrArrayOrString,
  flex: PropTypes.number,
  helpTooltip: PropTypes.string
};

export default ModalField;
